var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "style-btn-box" },
    [
      _c("div", [
        _c("div", { staticClass: "font-weight-bold" }, [
          _vm._v(_vm._s(_vm._f("trans")("Style"))),
        ]),
      ]),
      _vm._v(" "),
      _c("router-link", {
        attrs: {
          to: {
            name: "StyleCanvas",
            params: { uuid: _vm.id, activeStageId: _vm.activeStage.id },
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ href, route, navigate, isActive, isExactActive }) {
              return [
                _c(
                  "div",
                  { staticClass: "style-btn", on: { click: navigate } },
                  [
                    _c("div", { staticClass: "style-btn-left" }, [
                      _c("div", [
                        _c("img", {
                          attrs: {
                            alt: _vm.currentStyle.name,
                            srcset: `${_vm.currentStyle.path.sidebar["1x"]} 1x,  ${_vm.currentStyle.path.sidebar["2x"]} 2x, ${_vm.currentStyle.path.sidebar["3x"]} 3x,  ${_vm.currentStyle.path.sidebar["4x"]} 4x`,
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.currentStyle.name))]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "fa fa-chevron-right" }),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }